import { useRef } from 'react';

const useRefs = () => {
  const refsByKey = useRef<Record<string, HTMLElement | null>>({});

  const setRef = (element: HTMLElement | null, key: number) => {
    refsByKey.current[key] = element;
  };

  return { refsByKey: refsByKey.current, setRef };
};

export default useRefs;
